module.exports = __webpack_public_path__ + "static/media/Unterrichtsmaterialien_KI_ChatGPT_X76_16_4.f81a81eb.pdf";